import { InteractionRequiredAuthError, PublicClientApplication } from "@azure/msal-browser";
import { jwtDecode } from "jwt-decode";

export const getAccessToken = async (msalInstance: PublicClientApplication): Promise<string | null> => {
  const accounts = msalInstance.getAllAccounts();

  if (!accounts.length) {
    console.warn("No signed-in accounts found.");
    return null;
  }

  const activeAccount = accounts[0];
  msalInstance.setActiveAccount(activeAccount);

  const tokenRequest = {
    scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`],
    account: activeAccount,
  } as any;

  try {
    const response = await msalInstance.acquireTokenSilent(tokenRequest as any);
    if (response && (response as any).accessToken) {
      console.info("Acquired token silently.");
      return (response as any).accessToken;
    }
  } catch (error: any) {
    console.warn("Silent token acquisition failed:", error);

    if (error instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup(tokenRequest as any);
        if (response && (response as any).accessToken) {
          console.info("Acquired token via popup.");
          return (response as any).accessToken;
        }
      } catch (popupError) {
        console.error("Interactive token acquisition failed:", popupError);
        return null;
      }
    } else {
      console.error("Non-interaction error during token acquisition:", error);
      return null;
    }
  }

  return null;
};

export const isTokenExpired = (accessToken?: string | null): boolean => {
  if (!accessToken) return true;

  try {
    const decoded: any = jwtDecode(accessToken);
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    console.error("Failed to decode token:", error);
    return true;
  }
};

export const getValidAccessToken = async (msalInstance: PublicClientApplication, currentToken?: string | null): Promise<string | null> => {
  if (!currentToken || isTokenExpired(currentToken)) {
    return await getAccessToken(msalInstance);
  }
  return currentToken ?? null;
};
